import { SSRPermissionsErrorHandler } from '../src/SSRPermissionsErrorHandler.ts';

export const ssrPermissionsErrorHandler: SSRPermissionsErrorHandler =
	new SSRPermissionsErrorHandler();
